import { render, staticRenderFns } from "./hospital-table.vue?vue&type=template&id=27dff762&"
import script from "./hospital-table.vue?vue&type=script&lang=js&"
export * from "./hospital-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports